module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO MARQUESBRANDING_DESTAQUES-7e5b1a3119e51f9e94d16c5f084b48a3.png";